export type SortableEvent = {
    oldIndex: number;
    newIndex: number;
    /** Index among the elements matching the Sortable `draggable` option; equals oldIndex when every child is draggable. */
    oldDraggableIndex: number;
    /** Index among the elements matching the Sortable `draggable` option; equals newIndex when every child is draggable. */
    newDraggableIndex: number;
};

export function adaptToSortableUpdate<T>(sortableEvent: SortableEvent, collection: readonly T[]): T[] {
    const from = sortableEvent.oldIndex;
    const to = sortableEvent.newIndex;

    const cloned = [...collection];

    const [item] = cloned.splice(from, 1);
    cloned.splice(to, 0, item);

    return cloned;
}
